import { TCommonData, TWidgetProps } from '@libs/types';
import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';
import success from '../../animations/success.json';
import { sanitizeLottieName } from '../../utils/sanitize';
import { getInlineStyles } from '../../utils/styles';

export const SuccessAnimation: React.FC<TWidgetProps<TCommonData>> = ({ widget }) => {
    const element = useRef<HTMLDivElement>(null);
    const sanitizedUid = sanitizeLottieName(widget.uid);
    useEffect(() => {
        if (element.current) {
            lottie.loadAnimation({
                name: sanitizedUid,
                container: element.current,
                animationData: success,
                renderer: 'svg',
                loop: false,
                autoplay: true,
            });
        }
        return () => {
            lottie.destroy(sanitizedUid);
        };
    }, [sanitizedUid]);
    return <div data-test={widget.uid} ref={element} style={getInlineStyles({ margin: widget.options?.margin, height: '73px', width: '73px' })} />;
};
